import React, { useState, useImperativeHandle, forwardRef, useEffect, useRef } from 'react'
import Api from '../../../../../_helpers/Api'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import Pagination from '../../../../Pagination'
import { trans } from '../../../../../_providers/Translation'
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"

//images
import docIcon from '../../../../../assets/img/icons/document.png'
import checkIcon from '../../../../../assets/img/icons/check.png'
import closeIcon from '../../../../../assets/img/icons/close.png'
import loader from '../../../../../assets/img/loader.svg'
import { Checkbox } from '@mui/material'
import NoDataFound from '@/components/partials/NoDataFound'


//modals

let timeOut

function AddDevices(props, ref) {
    const params = useParams()
    const id = params.id

    const location = useLocation()

    const [state, setState] = useState({
        overlay: false,
        modal: false,
        data: [],
        checkedDevices: [],
        loading: false,
        loadingButtons: false,
        name: "",
        number: "",
        pages: 0,
        page: new URLSearchParams(location.search).get('page') || 1,
        updateData: false,
    })

    useImperativeHandle(ref, () => ({
        open: () => {
            handleOpen()
        },
        close: () => {
            handleClose()
        }
    }))

    useEffect(() => {
        if (state.modal) {
            loadData()
        }
    }, [state.updateData, state.modal])

    const handleOpen = () => {
        setState(state => ({
            ...state,
            overlay: true,
        }))

        setTimeout(() => {
            setState(state => ({
                ...state,
                modal: true,
            }))
        }, 50)
    }

    const handleClose = e => {
        if (e) e.preventDefault()

        setState(state => ({
            ...state,
            modal: false,
        }))

        setTimeout(() => {
            setState(state => ({
                ...state,
                overlay: false,
                params: null,
                data: [],
                name: "",
                number: "",
                checkedDevices: [],
                pages: 0,
                page: 1,
            }))
        }, 50)
    }

    const handleSearch = (e) => {
        let name = e.target.name
        let val = e.target.value


        setState(prev => ({
            ...prev,
            [name]: val
        }))

        clearTimeout(timeOut)

        setState(prev => ({
            ...prev,
            loading: true,
        }))

        timeOut = setTimeout(() => {
            setState(prev => ({
                ...prev,
                updateData: new Date().getTime()
            }))
        }, 300)

    }

    const loadData = () => {
        setState(prev => ({
            ...prev,
            loading: true
        }))

        Api.get(`storage/find-stock-device?name=${state.name}&number=${state.number}&page=${state.page}`)
            .then(res => {
                setState(prev => ({
                    ...prev,
                    data: res.data.items,
                    pages: res.data.pages
                }))
            }).finally(() => {
                setState(prev => ({
                    ...prev,
                    loading: false,
                }))
            })
    }

    const handlePage = page => {
        setState(state => ({ ...state, page: page.selected + 1, updateData: new Date().getTime() }))
    }


    const handleAddNewDevice = (e) => {
        e.preventDefault()

        const formData = new FormData(e.target)

        setState(prev => ({
            ...prev,
            loadingButtons: true
        }))

        Api.post('reservations/devices/add', formData).then(() => {
            props.refreshData()
        })
            .finally(() => {
                setState(prev => ({
                    ...prev,
                    loadingButtons: false
                }))
            })
    }

    const highlight = (string, search) => {
        if (!string) {
            return string
        }

        let regex = new RegExp(search, 'gi')

        let str = string.replace(regex, str => {
            return '<b style="color: #0088ff">' + str + '</b>'
        })

        return str
    }

    const createMarkup = str => {
        return { __html: str }
    }

    function handleCheck(e, id, storage_location_id) {
        let checked = e.target.checked
        let checkedDevices = [...state.checkedDevices]

        if (checked) {
            if (!checkedDevices.find(item => item.id === id)) {
                checkedDevices.push({ id, storage_location_id })
            }
        } else {
            checkedDevices = checkedDevices.filter(item => item.id !== id)
        }

        setState(state => ({
            ...state,
            checkedDevices
        }))
    }

    return (

        <>
            <div className={`${state.overlay ? 'visible' : ''} overlay`}>
                <form onSubmit={handleAddNewDevice} className={`${state.modal ? 'show' : ''} popup-primary large`}>
                    <input type="hidden" name="reservation_id" value={id} />

                    {state.checkedDevices.map((device, index) =>
                        <React.Fragment key={device.id}>
                            <input type="hidden" name={`part_id[${index}]`} value={device.id} />
                            <input type="hidden" name={`storage_location_id[${index}]`} value={device.storage_location_id ?? ''} />
                        </React.Fragment>
                    )}

                    <div className='head-new'>
                        <img src={popupDefaultHeadImage} alt="icon" />
                        <div className='texts'>
                            <h2>
                                {trans('headings.addDevice')}
                            </h2>
                            <p>{trans('subheadings.addDevice')}</p>
                        </div>
                        <span className='close' onClick={handleClose}>

                        </span>
                    </div>
                    <div className="row">

                        <div className="col">
                            <label>
                                {trans('labels.name')}
                            </label>
                            <input
                                type="search"
                                name="name"
                                value={state.name || ''}
                                onChange={handleSearch}
                            />
                        </div>

                        <div className="col">
                            <label>
                                {trans('labels.number')}
                            </label>
                            <input
                                type="search"
                                name="number"
                                value={state.number || ''}
                                onChange={handleSearch}
                            />
                        </div>

                    </div>

                    <br />

                    <div className="popup-container-read-only">
                        {state.loading ?
                            <img src={loader} alt="loading" />
                            :
                            state.data.length > 0
                                ?
                                <>
                                    <div className="table-scroller">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>

                                                    </th>
                                                    <th>ID</th>
                                                    <th>{trans('tables.name')}</th>
                                                    <th>{trans('tables.number')}</th>
                                                    <th>{trans('tables.category')}</th>
                                                    <th>{trans('tables.storage')}</th>
                                                    <th className="center">{trans('tables.quantity')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {state.data.map(row =>
                                                    <tr key={'device-' + (row.device.id || row.product.id)}>
                                                        <td
                                                            className="checkbox"
                                                            style={{
                                                                paddingLeft: '20px'
                                                            }}
                                                        >
                                                            <Checkbox
                                                                onChange={(e) => handleCheck(e, (row.device.id || row.product.id), row.storage_location_id)}
                                                                data-id={(row.device.id || row.product.id)}
                                                                size='small'
                                                            />
                                                        </td>
                                                        <td>
                                                            {row.device.id}
                                                        </td>
                                                        <td>
                                                            <span dangerouslySetInnerHTML={createMarkup(
                                                                highlight(row.device.name, state.name)
                                                            )} />
                                                        </td>
                                                        <td>
                                                            <span dangerouslySetInnerHTML={createMarkup(
                                                                highlight(row.device.number, state.number)
                                                            )} />
                                                        </td>
                                                        <td>
                                                            {row.device.category ? row.device.category.name : ''}
                                                        </td>
                                                        <td>
                                                            {row?.storage_location_name || '-'}
                                                        </td>
                                                        <td className="center">
                                                            {row.quantity > 0
                                                                ?
                                                                <img src={checkIcon} height={12} />
                                                                :
                                                                <img src={closeIcon} height={12} />
                                                            }
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <Pagination
                                        pages={state.pages}
                                        page={state.page}
                                        handlePage={handlePage}
                                    />
                                </>
                                :
                                <NoDataFound />
                        }
                    </div>

                    <div className="footer align-right">
                        {state.loadingButtons ?
                            <img src={loader} alt="loading" />
                            :
                            <>
                                <button type="button" onClick={handleClose}>
                                    {trans('buttons.cancel')}
                                </button>

                                <button type="submit" className="button button-primary" disabled={!state.checkedDevices.length}>
                                    {trans('buttons.add')}
                                </button>
                            </>
                        }
                    </div>
                </form>
            </div>
        </>
    )
}

export default forwardRef(AddDevices)